module.exports = __webpack_public_path__ + "img/Rollux.83306bec.webp";